export const ZIP_ERROR =
  'Please enter alfa numeric, “-”, “ “  from 1 up to 10 symbols';

export const REQUIRED_FIELD = 'This field is required';

export const COMMON_API_ERROR = 'Something went wrong, please try again';

export const ADDRESS_EXISTS = 'This address already exists';
